import React from 'react';
import { FormBuilder, Loader } from 'commons-ui';
import useEdit from './useEdit';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationEditSchema } from '../../utils/formConfig';

const EditCashbackUtil: React.FC<{}> = () => {
	const { data, handleFormCancel, showLoader, handleFormSubmit } = useEdit();
	return (
		<>
			{showLoader && <Loader />}
			<FormBuilder
				data={data}
				mode='edit'
				showLoader={false}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={false}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationEditSchema}
			/>
		</>
	);
};

export default EditCashbackUtil;
